import * as Endpoints from '../Entities/EndPoints'
import Axios from '../Axios'
import { paramReplacer, PARAMS } from 'src/Entities/AuthEntities'

const API = Axios.getInstance

export const sendEmailWithOTP = (emailId) => {
    let URL = Endpoints.SEND_LOGIN_WITH_OTP
    URL = URL.replace('{emailId}', emailId)

    return API(Endpoints.API_ENDPOINT)
        .post(URL)
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const LogUserLoginApi = (data) => {
    let api = Endpoints.LOGIN_USER_LOG
    Object.keys(data).forEach(key => {
        api = paramReplacer(api, key, data[key])
    })
    return API(Endpoints.API_ENDPOINT)
        .post(api)
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const verifyEmailWithOTP = (emailId, otp) => {
    let URL = Endpoints.VERIFY_LOGIN_WITH_OTP
    URL = URL.replace('{emailId}', emailId)
    URL = URL.replace('{otp}', otp)

    return API(Endpoints.API_ENDPOINT)
        .post(URL)
        .then((response) => response)
        .catch((err) => ({ err }))
}
export const getAllOrganizationByEmail = (emailId) => {
    return API(Endpoints.API_ENDPOINT)
        .post(paramReplacer(Endpoints.GET_ALL_ORGANIZATION_BY_MAIL, PARAMS.EMAIL, emailId))
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const getDataByOrganization = (emailId, orgId) => {
    let URL = paramReplacer(Endpoints.GET_DATA_BY_ORGANIZATION, PARAMS.EMAIL, emailId)
    URL = paramReplacer(URL, PARAMS.ORGID, orgId)
    return API(Endpoints.API_ENDPOINT)
        .post(URL)
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const sendInnviteFronOnboarding = (orgId, emailId) => {
    let URL = Endpoints.SEND_INVITE_FROM_ONBOARDING
    URL = URL.replace('{orgId}', orgId)
    if (emailId === null) {
        URL = URL.replace('&emailId={emailId}', '')
    } else if (emailId !== undefined) {
        URL = URL.replace('{emailId}', emailId)
    }
    return API(Endpoints.API_ENDPOINT)
        .post(URL)
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const getAccessToken = () => {
    return API(Endpoints.API_ENDPOINT)
        .post(Endpoints.GET_ACCESS_TOKEN, {}, {
            headers: { 'Content-Type': 'application/json' }
        })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const getRefreshToken = (refreshTokens) => {
    return API(Endpoints.API_ENDPOINT)
        .post(Endpoints.GET_REFRESH_TOKEN, JSON.stringify(refreshTokens), {
            headers: { 'Content-Type': 'application/json' }
        })
        .then((response) => response)
        .catch((err) => ({ err }))
}
